"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PureLayoutSection = exports.LayoutSection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
require("./LayoutSection.css");
var Row_1 = require("../../components/Row");
var Button_1 = require("../../components/Button");
var classnames_1 = __importDefault(require("classnames"));
var css_1 = require("@emotion/css");
var useFollowingClass_1 = require("../../hooks/useFollowingClass");
var LayoutSection = function (_a) {
  var _b = _a.startExpanded,
    startExpanded = _b === void 0 ? false : _b,
    restProps = __rest(_a, ["startExpanded"]);
  var _c = __read((0, react_1.useState)(startExpanded), 2),
    expanded = _c[0],
    setExpanded = _c[1];
  return (0, jsx_runtime_1.jsx)(exports.PureLayoutSection, __assign({
    expanded: expanded,
    setExpanded: setExpanded
  }, restProps));
};
exports.LayoutSection = LayoutSection;
var PureLayoutSection = function (_a) {
  var label = _a.label,
    className = _a.className,
    disableFormPageBlockAdjust = _a.disableFormPageBlockAdjust,
    children = _a.children,
    _b = _a.repeatAdjust,
    repeatAdjust = _b === void 0 ? 0 : _b,
    expanded = _a.expanded,
    setExpanded = _a.setExpanded,
    rowProps = _a.rowProps,
    titleGrow = _a.titleGrow,
    restProps = __rest(_a, ["label", "className", "disableFormPageBlockAdjust", "children", "repeatAdjust", "expanded", "setExpanded", "rowProps", "titleGrow"]);
  var toggleExpand = function () {
    return setExpanded(!expanded);
  };
  var ref = (0, react_1.useRef)(null);
  var adjustClass = (0, css_1.css)({
    "&+.vsx-layout-section": {
      marginTop: "".concat(repeatAdjust * -1, "px")
    }
  });
  var noBottomBorderClass = (0, useFollowingClass_1.useFollowingClass)({
    ref: ref,
    checkClassName: "vsx-layout-section",
    applyClassName: "vsx-layout-section-no-bottom-border"
  });
  var cn = (0, classnames_1.default)("vsx-layout-section", className, adjustClass, disableFormPageBlockAdjust && "disable-form-page-block-adjust", noBottomBorderClass);
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: cn,
    ref: ref
  }, restProps, {
    children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      spacing: "small",
      paddingBottom: expanded ? "none" : undefined,
      align: "center"
    }, rowProps, {
      children: [(0, jsx_runtime_1.jsx)(Button_1.IconButton, {
        role: "button",
        round: true,
        onClick: toggleExpand,
        icon: expanded ? "chevron-down" : "chevron-right"
      }), (0, jsx_runtime_1.jsx)("span", __assign({
        className: (0, classnames_1.default)("vsx-layout-section-title", titleGrow && "vsx-layout-section-title-grow"),
        onClick: toggleExpand
      }, {
        children: label
      }))]
    })), expanded && (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-layout-section-children"
    }, {
      children: children
    }))]
  }));
};
exports.PureLayoutSection = PureLayoutSection;